import { Component } from '@verndale/core';

class CartCounter extends Component {
  setupDefaults() {
    this.dom = {
      cartList: document.querySelector('.cart__items'),
      cartCounterMobile: document.querySelector(
        '.mobile-header__cart-button-counter'
      ),
      cartCounterDesktop: document.querySelector(
        '.desktop-header__cart-button-counter'
      ),
    };
  }

  checkCartItems(clean = false) {
    const cartItems = this.dom.cartList.querySelectorAll('.cart__item');
    if (cartItems.length > 0) {
      this.dom.cartCounterMobile.innerHTML = cartItems.length;
      this.dom.cartCounterMobile.removeAttribute('hidden');
      this.dom.cartCounterDesktop.innerHTML = cartItems.length;
      this.dom.cartCounterDesktop.removeAttribute('hidden');
    } else {
      this.dom.cartCounterMobile.setAttribute('hidden', true);
      this.dom.cartCounterDesktop.setAttribute('hidden', true);
    }

    if (clean) {
      this.dom.cartCounterMobile.setAttribute('hidden', true);
      this.dom.cartCounterDesktop.setAttribute('hidden', true);
    }
  }
}

export default CartCounter;
